import { addError, removeError } from '@core/utils/error-functions';
var DateIntervalValidation = /** @class */ (function () {
    function DateIntervalValidation() {
    }
    DateIntervalValidation.validate = function (_a) {
        var from = _a.from, to = _a.to, maxDiffLte = _a.maxDiffLte, unit = _a.unit;
        return function (formGroup) {
            var fromControl = formGroup.controls[from];
            var toControl = formGroup.controls[to];
            if (!fromControl.value || !toControl.value || !fromControl.value.isValid() || !toControl.value.isValid()) {
                return null;
            }
            var diff = toControl.value.diff(fromControl.value, unit, true);
            if (diff > maxDiffLte) {
                addError(fromControl, 'invalidRange');
                addError(toControl, 'invalidRange');
            }
            else {
                removeError(fromControl, 'invalidRange');
                removeError(toControl, 'invalidRange');
            }
            return null;
        };
    };
    return DateIntervalValidation;
}());
export { DateIntervalValidation };
